export default __webpack_public_path__ + "static/media/movitec.700d8f16.webp";